













































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { UtilitiesFunctions } from "@/helpers";

@Component
export default class GenericCard extends Vue {
  @Prop({ default: null }) private id!: string;
  @Prop({ default: false }) private homePageCard!: boolean; //Hack for layout refactor - remove after experience detail page ref
  @Prop({ default: null }) private avatar!: string;
  @Prop({ default: "" }) private cardType!: string;
  @Prop({ default: null }) private cardLink!: string;
  @Prop({ default: "" }) private cellarName!: string;
  @Prop({ default: "" }) private description!: string;
  @Prop({ default: null }) private experienceTags!: string;
  @Prop({ default: null }) private activityTags!: string;
  @Prop({ default: null }) private missionTags!: string;
  @Prop({ default: "" }) private imageUrl!: string;
  @Prop({ default: "265" }) private imageHeight!: string;
  @Prop({ default: null }) private address!: string;
  @Prop({ default: null }) private price!: string;
  @Prop({ default: null }) private priceSymbol!: string;
  @Prop({ default: null }) private priceType!: string;
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: false}) private instantBooking!: boolean

  // Per i prodotti: gestisce il fallback degli URL delle immagini
  private productImageUrlFallback: boolean = false;
  private productImageKey: number = 0;

  // get imageUrlProductCard() {
  //   return UtilitiesFunctions.imageUrlStringManager(
  //     "c_fill,h_200",
  //     this.imageUrl
  //   );
  // }

  // Computed property per l'URL dell'immagine prodotto con fallback
  get currentProductImageUrl(): string {
    if (this.cardType !== 'productCard') {
      return this.imageUrl;
    }
    
    // Se il fallback è già stato attivato, rimuovi /production/store/ dall'URL
    if (this.productImageUrlFallback && this.imageUrl) {
      return this.imageUrl.replace('/production/store/', '/');
    }
    
    return this.imageUrl;
  }

  // Handler per errori di caricamento immagini prodotti
  onProductImageError(event: Event) {
    if (this.cardType === 'productCard' && !this.productImageUrlFallback) {
      // Se l'immagine fallisce e contiene /production/store/, prova senza prefisso
      if (this.imageUrl && this.imageUrl.includes('/production/store/')) {
        this.productImageUrlFallback = true;
        // Incrementa la key per forzare il re-render dell'immagine con il nuovo URL
        this.productImageKey += 1;
      }
    }
  }

  goToLink(linkUrl: string, id: string) {
    const toRoute = UtilitiesFunctions.handleRoute(linkUrl);
    const ref = this.$route.query.ref as string;
    const tap_test = this.$route.query.tap_test as string;
    if (this.cardType === "experienceCard" || this.cardType === 'cellarCard') {
      let path = `${toRoute}/${id}`;
      let routeData = this.$router.resolve({
        path,
        query: { ref, tap_test } }
      );
      window.open(routeData.href, "_blank");
    } else {
      this.$router.push({ path: `${toRoute}/${id}` });
    }
  }
  openDetailPopup(id: string) {
    // console.log(id);
    this.$store
      .dispatch("app/setDialog", {
        type: "productDetail",
        state: true,
        childData: id
      })
      .then(() => {})
      .catch(error => {
        console.error(error);
      });
  }
}
